import { SVGProps, Ref, forwardRef } from 'react';

export const TinkoffBrandAltSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M1 1h22v11.064a7.94 7.94 0 0 1-3.97 6.877L12 23l-7.03-4.06A7.94 7.94 0 0 1 1 12.065z" fill="white" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.036 6.824v3.44c.472-.533 1.325-.892 2.304-.892h1.062v4.002c0 1.065-.288 1.995-.719 2.509h4.624c-.426-.514-.715-1.444-.715-2.506V9.375h1.062c.979 0 1.835.36 2.304.892v-3.44H7.033z"
            fill="#333333"
        />
    </svg>
));
TinkoffBrandAltSize24Glyph.displayName = 'TinkoffBrandAltSize24Glyph';
